
import { User as CoreUser } from '@portable/core/models';
import { UserApplicationModel } from './user-application-model.model';

class User extends CoreUser {
    id: number;
    corporationId: number;
    email: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
    isLockedOut: boolean;
    isDormant: boolean;
    isNonSSOUser: boolean;
    modifiedByUserName: string;
    modifiedDate: Date;
    userRole: UserRole;
    userApplicationModels: UserApplicationModel[];
    shouldResetPassword: boolean;
    clientId: number;
    ChildApplicationClientId: number;
		lastSuccessfulLoginDateTime: Date;
		roleName: string;
    isRootAdmin: string;
    name: string;
    ssoNameId: string;
    jobTitle:string;
    employeeId:string;
    upsertStatus:boolean;
    lastSuccessfulLoginDate:Date;

    constructor(options: any = { }) {
        super(options);
        this.userRole = new UserRole();
        this.userRole.roleId = options.roleId;
        this.userRole.roleName = options.roleName;
        this.userRole.friendlyName = options.friendlyName;

        this.userApplicationModels = options.userApplicationModels || this.userApplicationModels;
        return this;
    }

}

class UserRole {
    roleId: number;
		roleName: string;
		friendlyName: string;
}

export { User, UserRole };
